import { Table, Tooltip } from "antd";
import { useContext, useEffect, useState } from "react";

import { ExportToExcel } from "../../utils/exportExcel";

import { useQuery } from "@tanstack/react-query";
import Something from "../../components/shared/Something";
import Moment from "react-moment";
import UpdateRequester from "./components/UpdateRequester";
import {
  handleExportAutoRequests,
  handleFetchAutoRequests,
} from "../../api/autorequests";
import { Link } from "react-router-dom";
import { ColumnsType } from "antd/es/table";
import DeleteRequest from "./components/DeleteRequest";
import CompleteRequest from "./components/CompleteRequest";
import { AuthContext } from "../../contexts/AuthContext";
import { DeleteOutlined, EyeFilled, ReloadOutlined } from "@ant-design/icons";
import UpdateApprover from "./components/UpdateApprover";
import { Download, Users } from "lucide-react";
import MoveToExecutor from "./components/MoveToExecutor";
import UpdateExecutor from "./components/UpdateExecutor";
import UpdateBusiness from "./components/UpdateBusiness";
import ApproveRequest from "./components/ApproveRequest";
import UpdateRequestedFor from "./components/UpdateRequestedFor";
import UpdateRequestedDate from "./components/UpdateRequestedDate";
import UpdateApprovedDate from "./components/UpdateApprovedDate";
import UpdateExecutedDate from "./components/UpdateExecutedDate";

export default function AllAutoRequests({ status }: any) {
  const { user } = useContext(AuthContext);
  const [requesterModal, setRequesterModal] = useState<boolean>(false);
  const [requestedForModal, setRequestedForModal] = useState<boolean>(false);
  const [requestedDateModal, setRequestedDateModal] = useState<boolean>(false);
  const [approvedDateModal, setApprovedDateModal] = useState<boolean>(false);
  const [executedDateModal, setExecutedDateModal] = useState<boolean>(false);
  const [approverModal, setApproverModal] = useState<boolean>(false);
  const [executorModal, setExecutorModal] = useState<boolean>(false);
  const [unitModal, setUnitModal] = useState<boolean>(false);
  const [moveToExecutorModal, setMoveToExecutorModal] =
    useState<boolean>(false);
  const [deleteModal, setDeleteModal] = useState<boolean>(false);
  const [completeModal, setCompleteModal] = useState<boolean>(false);
  const [approveModal, setApproveModal] = useState<boolean>(false);
  const [isExporting, setExporting] = useState<boolean>(false);
  const [selected, setSelected] = useState<any>(null);
  const access = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];
  const adminAccess = [9];
  const approverAccess = [5, 9];
  const params = `&u=${user?._id}&a=${user?.accessLevel}`;

  const [pagination, setPagination] = useState<any>({
    page: 1,
    limit: 10,
    total: 0,
  });

  const {
    data: requests,
    refetch,
    isLoading,
    isFetching,
    isError,
  } = useQuery({
    queryKey: ["autorequests", pagination.page, pagination.limit, status],
    queryFn: () =>
      handleFetchAutoRequests({
        page: pagination.page,
        limit: pagination.limit,
        status: status || "",
        params,
      }),
  });

  const handlePageChange = (e: any) => {
    setPagination((prev: any) => ({
      ...prev,
      page: e.current,
      limit: e.pageSize,
    }));
  };

  interface DataType {
    key: React.Key;
    name: string;
    age: number;
    address: string;
  }

  interface DataType {
    key: React.Key;
    name: string;
    age: number;
    address: string;
  }
  const getColumns = (user: any, access: any) => {
    const columns: ColumnsType<DataType> = [
      {
        title: "S/N",
        width: 40,
        fixed: "left",
        render: (record: any, text: any, index: any) => (
          <span className="text-gray-700 ml-2">
            {pagination?.page * pagination?.limit -
              pagination?.limit +
              index +
              1}
          </span>
        ),
      },
      {
        title: "REQUESTED FOR",
        width: 200,
        fixed: "left",
        render: (record: any) => {
          return (
            <button
              onClick={() => {
                setSelected(record);
                setRequestedForModal(true);
              }}
              className="text-black"
            >
              {record?.requestedFor?.name || (
                <button className="border px-2 py-1 bg-gray-100 shadow-sm">
                  + Assign
                </button>
              )}
            </button>
          );
        },
      },
      {
        title: "FOR ROLE",
        width: 140,
        render: (record: any) => {
          return (
            <div className="text-gray-700">
              <div className="">{record?.designation || "-"}</div>
            </div>
          );
        },
      },

      {
        title: "REQUESTED BY",
        width: 200,
        render: (record: any) => {
          return (
            <button
              onClick={() => {
                setSelected(record);
                setRequesterModal(true);
              }}
              className="text-black"
            >
              {record?.requestedBy?.name || (
                <button className="border px-2 py-1 bg-gray-100 shadow-sm">
                  + Assign
                </button>
              )}
            </button>
          );
        },
      },
      {
        title: "REQUESTED AT",
        width: 140,
        render: (record: any) => (
          <button
            onClick={() => {
              setSelected(record);
              setRequestedDateModal(true);
            }}
            className="text-black"
          >
            {record?.dateRequested ? (
              <Moment format="DD/MM/YYYY">{record?.dateRequested}</Moment>
            ) : (
              "-"
            )}
          </button>
        ),
      },
      {
        title: "APPROVER",
        width: 250,
        render: (record: any) => (
          <div className="flex items-center gap-2">
            <button
              onClick={() => {
                setSelected(record);
                setApproverModal(true);
              }}
              className="text-black"
            >
              {record?.approvedBy?.name || (
                <div className="">
                  {adminAccess.includes(user?.accessLevel) && (
                    <button className="border px-2 py-1 bg-gray-100 shadow-sm">
                      + Assign
                    </button>
                  )}
                </div>
              )}
            </button>
            <span
              className={`${record?.approvalStatus === "Approved"
                ? "text-green-600"
                : "text-red-600"
                }`}
            >
              ({record?.approvalStatus})
            </span>
          </div>
        ),
      },
      {
        title: "APPROVED AT",
        width: 140,
        render: (record: any) => (
          <button
            onClick={() => {
              setSelected(record);
              setApprovedDateModal(true);
            }}
            className="text-black"
          >
            {record?.dateApproved ? (
              <Moment format="DD/MM/YYYY">{record?.dateApproved}</Moment>
            ) : (
              "-"
            )}
          </button>
        ),
      },
      {
        title: "EXECUTED BY",
        width: 200,
        render: (record: any) => (
          <button
            onClick={() => {
              if (adminAccess.includes(user?.accessLevel)) {
                setSelected(record);
                setExecutorModal(true);
              }
            }}
            className="text-black"
          >
            {record?.executedBy?.name || (
              <button className="border px-2 py-1 bg-gray-100 shadow-sm">
                + Assign
              </button>
            )}
          </button>
        ),
      },
      {
        title: "EXECUTED AT",
        width: 140,
        render: (record: any) => (
          <button
            onClick={() => {
              setSelected(record);
              setExecutedDateModal(true);
            }}
            className="text-black"
          >
            {record?.dateExecuted ? (
              <Moment format="DD/MM/YYYY">{record?.dateExecuted}</Moment>
            ) : (
              "-"
            )}
          </button>
        ),
      },
      {
        title: "STATUS",
        width: 250,
        render: (record: any) => (
          <span
            className={`text-gray-700 ${record?.isCompleted && "text-green-600"
              }`}
          >
            {record?.status || "-"}
          </span>
        ),
      },

      {
        title: "ACTIONS",
        width: 180,
        align: "center",
        fixed: "right",
        render: (record: any) => (
          <div className="flex justify-end">
            {!record?.isCompleted && record?.isApproved && (
              <button
                onClick={() => {
                  if (adminAccess.includes(user?.accessLevel)) {
                    setSelected(record);
                    setCompleteModal(true);
                  }
                }}
                className="border py-1 px-2 mx-1 flex items-center bg-red-50 text-red-800 shadow-sm hover:bg-green-100 hover:text-green-800"
              >
                Complete
              </button>
            )}

            {record?.approvalStatus === "Pending" &&
              record?.approvedBy?.email === user?.email && (
                <button
                  onClick={() => {
                    setSelected(record);
                    setApproveModal(true);
                  }}
                  className="border px-2 py-1 bg-gray-100 shadow-sm"
                >
                  Approve
                </button>
              )}


            {adminAccess.includes(user?.accessLevel) && (


              <button
                onClick={() => {
                  setSelected(record);
                  setUnitModal(true);
                }}
                className={`border py-1 px-2 mx-1 flex items-center bg-blue-50 text-blue-800 shadow-sm ${record?.businessUnit ? "bg-green-50 text-green-800" : ""
                  }`}
              >
                <Users size={15} />
                <span className="mx-1">B.U </span>
              </button>
            )}
            {adminAccess.includes(user?.accessLevel) && (

              <button
                onClick={() => {
                  if (adminAccess.includes(user?.accessLevel)) {
                    setSelected(record);
                    setDeleteModal(true);
                  }
                }}
                className="border py-1 px-2 mx-1 flex items-center bg-red-50 text-red-800 shadow-sm"
              >
                <DeleteOutlined />
              </button>
            )}
          </div>
        ),
      },
      {
        title: "DETAILS",
        width: 80,
        align: "center",
        fixed: "right",
        render: (record: any) => (
          <div className="flex justify-end">
            <Link
              to={`/autoline/requests/${record?._id}`}
              className="border py-1 px-2 mx-1 flex items-center bg-blue-50 text-blue-800 shadow-sm"
            >
              <EyeFilled /> <span className="mx-1">Details</span>
            </Link>
          </div>
        ),
      },
    ];
    return columns.filter((column: any) => {
      if (column.title === "ACTIONS") {
        return approverAccess.includes(user?.accessLevel);
      }
      return true;
    });
  };
  const columns = getColumns(user, access);

  const exportRequests = async () => {
    setExporting(true);
    const res = await handleExportAutoRequests();
    await ExportToExcel(
      res.records?.map((item: any, index: number) => {
        return {
          "S/N": index + 1,
          "Requested For": item?.name || "-",
          User: item?.isNewUser ? "New" : "Existing",
          Email: item?.email || "-",
          Mobile: item?.mobile || "-",
          "For Role": item?.designation || "-",
          Companies: item?.companies?.map((company: any) => company).join(", "),
          Levels: item?.levels?.map((level: any) => level).join(", "),
          "Requested By": item?.requestedBy?.name || "-",
          "Requested At": (
            <Moment format="DD/MM/YYYY">{item?.createdAt}</Moment>
          ),
          "Approved By": item?.approvedBy?.name || "-",
          "Approved At": (
            <Moment format="DD/MM/YYYY">{item?.dateApproved}</Moment>
          ),
          "Executed By": item?.executedBy?.name || "-",
          "Executed At": (
            <Moment format="DD/MM/YYYY">{item?.dateExecuted}</Moment>
          ),
          Status: item?.status || "-",
          Completed: item?.isCompleted ? "Yes" : "No",
        };
      }),
      "AutolineRequests.xlsx"
    );
    setExporting(false);
  };

  useEffect(() => {
    setPagination({ ...pagination, total: requests?.total });
  }, [requests]);

  return (
    <div className="bg-gray-100">
      <div className="bg-white m-1">
        <div className="flex flex-col sm:flex-row justify-between border p-2">
          <div className="">
            <div className="font-bold capitalize text-lg">
              Autoline Access Requests
            </div>
            <div className="text-gray-600">Manage all request approvals</div>
          </div>

          <div className="flex">
            <Tooltip title="Export To Excel">
              <button
                className="flex mx-2 justify-center items-center border px-4 h-8  hover:bg-gray-100 shadow-sm"
                onClick={() => exportRequests()}
              >
                {isExporting ? <ReloadOutlined /> : <Download size={12} />}
                <span className="mx-1">Export</span>
              </button>
            </Tooltip>
            {access?.includes(user?.accessLevel) && (
              <Link
                to={"/autoline/requests/new"}
                className="flex mx-2 justify-center items-center border px-4 h-8  bg-karimjee  hover:bg-karimjee-dark text-white shadow-sm"
              >
                + New
              </Link>
            )}
          </div>
        </div>
        {isError ? (
          <Something refetch={refetch} isFetching={isFetching} />
        ) : (
          <div className="border p-2">
            <Table
              size="small"
              dataSource={requests?.records}
              columns={columns}
              scroll={{ y: 660, x: "max-content" }}
              rowKey="id"
              bordered
              pagination={{
                current: pagination?.page,
                pageSize: pagination?.limit,
                total: pagination?.total,
              }}
              rowClassName={"hover:bg-gray-100 cursor-pointer"}
              onChange={(e: any) => handlePageChange(e)}
              loading={isLoading}
            />
          </div>
        )}
      </div>
      {requesterModal && (
        <UpdateRequester
          isVisible={requesterModal}
          setVisible={setRequesterModal}
          selected={selected || {}}
        />
      )}

      {requestedForModal && (
        <UpdateRequestedFor
          isVisible={requestedForModal}
          setVisible={setRequestedForModal}
          selected={selected || {}}
        />
      )}

      {requestedDateModal && (
        <UpdateRequestedDate
          isVisible={requestedDateModal}
          setVisible={setRequestedDateModal}
          selected={selected || {}}
        />
      )}
      {approvedDateModal && (
        <UpdateApprovedDate
          isVisible={approvedDateModal}
          setVisible={setApprovedDateModal}
          selected={selected || {}}
        />
      )}
      {approverModal && (
        <UpdateApprover
          isVisible={approverModal}
          setVisible={setApproverModal}
          selected={selected || {}}
        />
      )}
      {moveToExecutorModal && (
        <MoveToExecutor
          isVisible={moveToExecutorModal}
          setVisible={setMoveToExecutorModal}
          selected={selected || {}}
        />
      )}
      {executorModal && (
        <UpdateExecutor
          isVisible={executorModal}
          setVisible={setExecutorModal}
          selected={selected || {}}
        />
      )}
      {executedDateModal && (
        <UpdateExecutedDate
          isVisible={executedDateModal}
          setVisible={setExecutedDateModal}
          selected={selected || {}}
        />
      )}
      {deleteModal && (
        <DeleteRequest
          isVisible={deleteModal}
          setVisible={setDeleteModal}
          selected={selected || {}}
        />
      )}
      {completeModal && (
        <CompleteRequest
          isVisible={completeModal}
          setVisible={setCompleteModal}
          selected={selected || {}}
        />
      )}

      {unitModal && (
        <UpdateBusiness
          isVisible={unitModal}
          setVisible={setUnitModal}
          selected={selected || {}}
        />
      )}

      {approveModal && (
        <ApproveRequest
          isVisible={approveModal}
          setVisible={setApproveModal}
          selected={selected || {}}
        />
      )}
    </div>
  );
}
